'use client';

import animationData from '@/animations/ai-agents-v2.json';
import { FC } from 'react';
import LottieHandler from './LottieHandler';

export interface AnimationAiAgentsProps {
  playing?: boolean;
}

const AnimationAiAgents: FC<AnimationAiAgentsProps> = ({ playing }) => {
  return (
    <div className="flex">
      <LottieHandler animationData={animationData} playing={playing} />
    </div>
  );
};

export default AnimationAiAgents;
